import { useMemo } from "react";
import { usTimeZoneSelectRows } from "../lib/usIanaTimeZones.js";

type Props = {
  value: string;
  onChange: (ianaId: string) => void;
  allowEmpty?: boolean;
  emptyLabel?: string;
  className?: string;
};

export function UsTimeZoneSelect(props: Props) {
  const { value, onChange, allowEmpty, emptyLabel = "Select a US time zone…", className = "select" } = props;
  const rows = useMemo(() => usTimeZoneSelectRows(value), [value]);

  return (
    <select
      className={className}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label="US time zone"
    >
      {allowEmpty ? <option value="">{emptyLabel}</option> : null}
      {rows.map((row) => (
        <option key={row.id} value={row.id}>
          {row.label} ({row.id})
        </option>
      ))}
    </select>
  );
}
